export default __webpack_public_path__ + "static/media/Maduro1Closed.9dcafccf.jpg";